import React, { useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import axios from 'axios';
import { apiService } from "_helpers";

export function CenterConfigModal({
  show,
  onClose,
  centerData,
  doctorList,
  onSave,
}) {
  const [formData, setFormData] = useState(centerData || {});
  const [doctorAssignStudyList, setDoctorAssignStudyList] = useState([]);

  const authUser = useSelector(x => x.auth.user);
  const dispatch = useDispatch();
  
  const fieldDependencies = {
    header_margin: (value, prev) => ({
      header_bodyarea: value + 140,
    }),
    footer_margin: (value, prev) => ({
      footer_bodyarea: value + 140,
    }),
    header_bodyarea: (value, prev) => ({
      header_margin: value - 140,
    }),
    footer_bodyarea: (value, prev) => ({
      footer_margin: value - 140,
    }),
    default_priority_level: () => ({}),
    interval_time_gap: () => ({}),
    default_doctor_key: () => ({}),
    review_flag: () => ({}),
    study_consider_series_flag: () => ({}),
    assign_dr_allow: () => ({}),
    assign_dr_notes: () => ({}),
  };

  const handleChangeAssignDoctor = (e) => {
    const { name, value } = e.target;
    
    let changeValue = '';
    if(name==='review_flag' || name==='study_consider_series_flag' 
      || name==='assign_dr_allow' || name==='assign_dr_notes'){
      changeValue = value;
    }
    else{
      changeValue = Number(value);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    let changeValue = '';
    if(name==='review_flag' || name==='study_consider_series_flag' 
      || name==='assign_dr_allow' || name==='assign_dr_notes'){
      changeValue = value;
    }
    else{
      changeValue = Number(value);
    }
    

    setFormData((prev) => {
      let updated = { ...prev, [name]: changeValue };

      if (fieldDependencies[name]) {
        updated = {
          ...updated,
          ...fieldDependencies[name](changeValue, prev),
        };
      }

      return updated;
    });

  };

  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  const getStudyRateList = async () => {
    const center_key = formData.center_key;
    const user_key = authUser?.user_key;
    const url = `${process.env.REACT_APP_API_URL}/center/GetCenterDoctorAssign?user_key=`+user_key.toString() + `&center_key=`+center_key.toString();
    const data = await apiService.get(url, dispatch);
    if (Array.isArray(data) && data.length > 0) {
      setDoctorAssignStudyList(data);
    }
  };
  const onSaveDoctorAssign = async () => {    
    try {
      const url = `${process.env.REACT_APP_API_URL}/center/UpdateCenterRate`;      
      let filteredData = doctorAssignStudyList.filter((item) => {
            return item.action_flag !== "V";
        });

      const formData = new FormData();

      filteredData.forEach((item, index) => {
        formData.append(`CenterRateList[${index}].center_key`, item.center_key);
        formData.append(`CenterRateList[${index}].rate_key`, item.rate_key);        
        formData.append(`CenterRateList[${index}].single_service_rate`, item.single_service_rate);        
        formData.append(`CenterRateList[${index}].double_service_rate`, item.double_service_rate);        
      });

      const user_key = authUser?.user_key;
      const request_id = randomNumberInRange(1000000, 9000000);
      const user = JSON.parse(localStorage.getItem("user"));
      const token = user?.token || null;

       const response = await axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`,
            'user_key': user_key.toString(),
            'request_id': request_id.toString(),
          },
        });
      
      if (response?.success) {        
        getStudyRateList();

        alert("Center rate updated successfully.");
      } else {
        alert("Failed to update center rate. Please try again.");
      }
    } catch (error) {
      alert("An error occurred while updating center rate.");
    }
  }
  const addAssignDoctor = (e) => {
    e.preventDefault();
    //setDoctorAssignStudyList(null);
  }
  const openAssignDoctor = (e, param, index, action_tag) => {
    e.preventDefault();
      
      if(index!=null){
        
      }

      if(param === 'OPEN'){
        getStudyRateList();
      }

      if(param === 'SAVE'){
        onSaveDoctorAssign();
      }

      let modal = document.querySelector("#assignDoctor");
      modal.classList.toggle("closed");
  };
  
  return (
    <div>
    <div className="centered-modal" style={{zIndex:"21055"}}>
      <div className="modal-header pt-2">
          <span className="close" id="close-button" onClick={onClose}>&times;</span>
          <h6 className="mb-0"><i className="bi bi-person-circle"></i> Report/Doctor Setup: {formData?.center_name}</h6>
      </div>
      <div className="modal-body" style={{paddingTop:"0.5px"}}>
        <div className="modal-row">
          <div className="modal-column input-group-text">
            <b>Report Layout <i>(Report Format 1 line equal to 20)</i></b>
          </div>
        </div>

        <div className="modal-row">
          <div className="modal-column">
            <label>
              Header Margin:
              <input
                type="number"
                name="header_margin"
                value={formData?.header_margin ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={0}
              />
            </label>
          </div>
          <div className="modal-column">
            <label>
              Header Body:
              <input
                type="number"
                name="header_bodyarea"
                value={formData?.header_bodyarea ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={140}
              />
            </label>
          </div>
        
          <div className="modal-column">
            <label>
              Footer Margin:
              <input
                type="number"
                name="footer_margin"
                value={formData?.footer_margin ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={0}
              />
            </label>
          </div>
          <div className="modal-column">
            <label>
              Footer Body:
              <input
                type="number"
                name="footer_bodyarea"
                value={formData?.footer_bodyarea ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={140}
              />
            </label>
          </div>
        </div>
        
        <div className="modal-row">
          <div className="modal-column input-group-text">
            <b>Workflow</b>
          </div>
        </div>

        <div className="modal-row">
          
          <div className="modal-column">
            <label title="DICOM tag read series to consider as study name">Study as series:
              <select
                className="modal-input"
                id="ddlstudy_consider_series_flag"
                name="study_consider_series_flag"
                onChange={handleChange}
              >
                <option value="N"
                  selected={"N" === formData?.study_consider_series_flag}
                >No</option>
                <option value="Y"
                  selected={"Y" === formData?.study_consider_series_flag}
                >Yes</option>
              </select>
            </label>
          </div>
          <div className="modal-column">
            <label>
              Interval Gap:
              <input
                type="number"
                name="interval_time_gap"
                value={formData?.interval_time_gap ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={0}
              />
            </label>
          </div>
          <div className="modal-column">
            <label>
              Priority Level:
              <select
                className="modal-input"
                id="ddldefault_priority_level"
                name="default_priority_level"
                onChange={handleChange}
              >
                <option value="0"
                  selected={0 === formData?.default_priority_level}
                >None</option>
                <option value="1"
                  selected={1 === formData?.default_priority_level}
                >Low</option>
                <option value="2"
                  selected={2 === formData?.default_priority_level}
                >High</option>
              </select>

            </label>
          </div>
          
          <div className="modal-column">
            <label>Report Review:
              <select
                className="modal-input"
                id="ddlreview_flag"
                name="review_flag"
                onChange={handleChange}
              >
                <option value="N"
                  selected={"N" === formData?.review_flag}
                >No</option>
                <option value="Y"
                  selected={"Y" === formData?.review_flag}
                >Yes</option>
              </select>
            </label>
          </div>

        </div>

        <div className="modal-row">
          <div className="modal-column input-group-text">
            <b>Default Doctors</b>
            <button style={{display:"none"}} id="btnDoctorAssign" type="button" className="btn btn-outline-warning btn-sm2 bi bi-activity m-1" style={{ display: "inline" }} title="Activity Log" onClick={event => openAssignDoctor(event, 'OPEN', 0, null)}></button>
          </div>
        </div>
        <div className="modal-row">
          <div className="modal-column">
            <label>
              X-Ray Doctor:
              <select
                className="modal-input"
                id="ddlDoctorList"
                name="default_doctor_key"
                onChange={handleChange}
              >
                <option value="">[Select Doctor]</option>
                {doctorList.map((doctor, i) => (
                  <option
                    key={i}
                    value={doctor.doctor_key}
                    selected={doctor.doctor_key === formData.default_doctor_key}
                  >
                    {doctor.doctor_name}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <div className="modal-column">
            <label>
              CT/MRI Doctor:
              <select
                className="modal-input"
                id="ddlDoctorListCT"
                name="default_doctor_key_ct"
                onChange={handleChange}
              >
                <option value="">[Select Doctor]</option>
                {doctorList.map((doctor, i) => (
                  <option
                    key={i}
                    value={doctor.doctor_key}
                    selected={doctor.doctor_key === formData.default_doctor_key_ct}
                  >
                    {doctor.doctor_name}
                  </option>
                ))}
              </select>
            </label>
            
          </div>
        
          <div className="modal-column">
            <label>
              ECG Doctor:
              <select
                className="modal-input"
                id="ddlDoctorListECG"
                name="default_doctor_key_ecg"
                onChange={handleChange}
              >
                <option value="">[Select Doctor]</option>
                {doctorList.map((doctor, i) => (
                  <option
                    key={i}
                    value={doctor.doctor_key}
                    selected={doctor.doctor_key === formData.default_doctor_key_ecg}
                  >
                    {doctor.doctor_name}
                  </option>
                ))}
              </select>
            </label>
          </div>
          
        </div>

        <div className="modal-row">
          <div className="modal-column">
            <label>Allow Doctor Assign:
              <select
                className="modal-input"
                id="ddlassign_dr_allow"
                name="assign_dr_allow"
                onChange={handleChange}
              >
                <option value="N"
                  selected={"N" === formData?.assign_dr_allow}
                >No</option>
                <option value="Y"
                  selected={"Y" === formData?.assign_dr_allow}
                >Yes</option>
              </select>
            </label>
          </div>

          <div className="modal-column">
            <label>Doctor Assign Notes:</label>
            <input
              type="text"
              name="assign_dr_notes"
              value={formData.assign_dr_notes || ""}
              onChange={handleChange}
              className="modal-input"
            />
          </div>
        </div>
        
      </div>

      <div className="modal-actions" style={{marginTop:"0px"}}>
        <div className="col-lg-4 col-4"><button type="button"
                className="btn btn-secondary btn-sm btn-block bi bi-save2-fill" id="btnConfigSave" onClick={() => onSave(formData)}> SAVE</button></div>
        <div className="col-lg-3 col-4"><button type="button"
                className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnConfigClose" onClick={onClose}> CLOSE</button></div>
      </div>
    </div>

    {/*<!--Custom Modal Open Notes -->*/}
            <div id="assignDoctor" className="modal closed" style={{zIndex:"21056"}}>
              {/*<!--Modal content -->*/}
              <div className="assignDoctorStudy-modal-content">
                  <div className="modal-header pt-2">
                      <span className="close" onClick={event => openAssignDoctor(event, 'CLOSE', null, null)}>&times;</span>
                      <h6 className="mb-0" style={{marginTop: "0.3em"}}><i className="bi bi-clipboard-check-fill"></i> Assign Doctor: <span id="spnlog_patient" style={{fontSize: "12px"}}></span></h6>
                  </div>
                  
                  <div className="modal-body" style={{overflow:"auto"}}>
                    <div className="card-header bg-gradient-1 text-light">
                      {/* Table Heading */}
                      <div className="row">
                        <div className="col-2 col-sm-2 col-md-1">
                          <p className="tele-table-heading">
                            Level
                          </p>
                        </div>
                        <div className="col-1 col-sm-1 col-md-1">
                          <p className="tele-table-heading">
                            Modality
                          </p>
                        </div>
                        <div className="col-2 col-sm-2 col-md-1">
                          <p className="tele-table-heading">
                            Study Name
                          </p>
                        </div>
                        <div className="col-2 col-sm-2 col-md-1">
                          <p className="tele-table-heading">Target</p>
                        </div>
                        <div className="col-2 col-sm-2 col-md-1">
                          <p className="tele-table-heading">Available</p>
                        </div>
                        <div className="col-2 col-sm-2 col-md-1 d-none d-sm-block">
                          <p className="tele-table-heading">Reassign Doctor</p>
                        </div>
                        <div className="col-2 col-sm-2 col-md-1">
                          <p className="tele-table-heading">Available</p>
                        </div>
                        <div className="col-2 col-sm-2 col-md-1">
                          <p className="tele-table-heading">Only Priority Reassign</p>
                        </div>
                        <div className="col-2 col-sm-2 col-md-1">
                          <p className="tele-table-heading">Estimate Time</p>
                        </div>
                        <div className="col-2 col-sm-2 col-md-1">
                          <p className="tele-table-heading">Reassign Time</p>
                        </div>
                        <div className="col-2 col-sm-2 col-md-1">
                          <p className="tele-table-heading">Priority Estimate Time</p>
                        </div>
                        <div className="col-2 col-sm-2 col-md-1">
                          <p className="tele-table-heading">Priority Reassign Time</p>
                        </div>
                        <div className="col-2 col-sm-2 col-md-1">
                          <p className="tele-table-heading">Updated On</p>
                        </div>
                      </div>
                    </div>
                    <div className="card-body tele-table-padding rate-studylist-area">
                      {/* tele-table-rowbg1 */}
                      <div className="row centerlist" id="divStudyRate"></div>
                      {doctorAssignStudyList.map((data, i) => (
                        <div key={i} className="row align-items-center studylist">
                          <div className="col-2 col-sm-2 col-md-1">
                            <p className="tele-table-dash-text">{data.priority_level}</p>
                          </div>
                          <div className="col-1 col-sm-1 col-md-1">
                            <p className="tele-table-dash-text">{data.modality}</p>
                          </div>
                          <div className="col-2 col-sm-2 col-md-1">
                            <p className="tele-table-dash-text">{data.study_name}</p>
                          </div>
                          <div className="col-2 col-sm-2 col-md-1">
                            <p className="tele-table-dash-text">
                              <select
                                className="modal-input"
                                id={`ddlDoctorTarget_${data.priority_level.toString()}`}
                                name="target_doctor_key"
                                onChange={handleChangeAssignDoctor}
                              >
                                <option value="">[Select Doctor]</option>
                                {doctorList.map((doctor, i) => (
                                  <option
                                    key={i}
                                    value={doctor.doctor_key}
                                    selected={doctor.doctor_key === data.target_doctor_key}
                                  >
                                    {doctor.doctor_name}
                                  </option>
                                ))}
                              </select>
                            </p>
                          </div>
                          <div className="col-2 col-sm-2 col-md-1">
                            <p className="tele-table-dash-text">{data.target_available_flag}</p>
                          </div>
                          <div className="col-2 col-sm-2 col-md-1">
                            <p className="tele-table-dash-text">
                              <select
                                className="modal-input"
                                id={`ddlDoctorReassign_${data.priority_level.toString()}`}
                                name="reassign_doctor_key"
                                onChange={handleChangeAssignDoctor}
                              >
                                <option value="">[Select Doctor]</option>
                                {doctorList.map((doctor, i) => (
                                  <option
                                    key={i}
                                    value={doctor.doctor_key}
                                    selected={doctor.doctor_key === data.reassign_doctor_key}
                                  >
                                    {doctor.doctor_name}
                                  </option>
                                ))}
                              </select>
                            </p>
                          </div>
                          <div className="col-2 col-sm-2 col-md-1">
                            <p className="tele-table-dash-text">{data.reassign_available_flag}</p>
                          </div>
                          <div className="col-2 col-sm-2 col-md-1">
                            <p className="tele-table-dash-text">{data.reassign_priority_flag}</p>
                          </div>
                          <div className="col-2 col-sm-2 col-md-1">
                            <p className="tele-table-dash-text">{data.estimate_time}</p>
                          </div>
                          <div className="col-2 col-sm-2 col-md-1">
                            <p className="tele-table-dash-text">{data.reassign_time}</p>
                          </div>

                          <div className="col-2 col-sm-2 col-md-1">
                            <p className="tele-table-dash-text">{data.priority_estimate_time}</p>
                          </div>
                          <div className="col-2 col-sm-2 col-md-1">
                            <p className="tele-table-dash-text">{data.priority_reassign_time}</p>
                          </div>
                          
                          <div className="col-2 col-sm-2 col-md-2">
                            <p className="tele-table-dash-text">
                              {data.updated_on}
                            </p>
                          </div>

                        </div>
                      ))}
                    </div>
                  </div>
    
                  <div className="modal-footer pt-2">
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-4"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-save2-fill" id="btnAssignDrAddRow" onClick={event => addAssignDoctor()}> ADD RECORD</button></div>
                        <div className="col-lg-4 col-4"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-save2-fill" id="btnAssignDrSave" onClick={event => openAssignDoctor(event, 'SAVE', null, null)}> SAVE</button></div>
                        <div className="col-lg-3 col-4"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnAssignDrClose" onClick={event => openAssignDoctor(event, 'CLOSE', null, null)}> CLOSE </button></div> 
                    </div>
                  </div>
    
              </div>
            </div>
            </div>
  );
}
